import * as d3 from 'd3';

export const groupColors = d3.scaleOrdinal(d3.schemeCategory10);
